import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import Form from 'components/Form';
import OnboardingFormContainer from 'components/containers/OnboardingFormContainer';
import ContentText from 'components/text/ContentText';
import HeroTitleText from 'components/text/HeroTitleText';
import OnboardingFooterText from 'components/text/OnboardingFooterText';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { FIRST_NAME_FIELD_NAME, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const OnboardingCurrentUserPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { WELCOME } = useTranslation();

    const {
        Component,
        bodyText,
        control,
        currentStep,
        errors,
        footerText,
        form,
        isRequired,
        name,
        onNext,
        placeholder
    } = useData();

    return (
        <Form form={form}>
            <Wrapper className={styles.wrapper} testId={testId}>
                <VerticalContainer className={styles.verticalContainer}>
                    <VerticalContainer>
                        {currentStep === FIRST_NAME_FIELD_NAME && <ContentText text={WELCOME} />}

                        <HeroTitleText text={bodyText} />
                    </VerticalContainer>

                    <OnboardingFormContainer errors={errors} onNext={onNext}>
                        <Component
                            control={control}
                            isRequired={isRequired}
                            name={name}
                            placeholder={placeholder}
                        />
                    </OnboardingFormContainer>
                </VerticalContainer>
            </Wrapper>

            <OnboardingFooterText className={styles.labelText}>{footerText}</OnboardingFooterText>
        </Form>
    );
};

export default OnboardingCurrentUserPage;
